import { useAuthenticator } from "@aws-amplify/ui-react";
import React from "react";
import NavBarItem from "./NavBarItem";
import NavBarLogo from "./NavBarLogo";

export default function NavBar() {
  const { signOut } = useAuthenticator(context => [context.user]);

  return (
    <nav className="navbar navbar-expand-lg navbar-container navbar-dark bg-primary">
      <div className="container-fluid">
        <NavBarLogo />
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="true"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-collapse collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <NavBarItem href="/" text="Content" />
            <NavBarItem href="/queues" text="Queues" />
          </ul>

          <button className="nav-link text-white" onClick={signOut}>
            <i className="bi bi-box-arrow-right"></i> Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}
